import Vue from 'vue'
import VueI18n from 'vue-i18n'
import LangENUS from '@/i18n/en-us'
import LangZHCN from '@/i18n/zh-cn'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'zh-cn',
  messages: {
    'en-us': LangENUS,
    'zh-cn': LangZHCN
  }
})

export default new Vue({ i18n })



// WEBPACK FOOTER //
// ./src/common/commoni18n.js